<template>
  <v-stepper class="elevation-0" v-model="currentLevel">
    <v-card-title v-if="isStage()" class="red--text my-12">
      !! STAGE !!
    </v-card-title>
    <p
      class="greytext--text text-h4 text-uppercase ml-9"
      v-html="$t('onboarding.form.title')"
    />
    <v-stepper-items>
      <v-stepper-content step="1">
        <verify-subtenant> </verify-subtenant>
      </v-stepper-content>

      <v-stepper-content step="2">
        <device-setup />
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import DeviceSetup from "./DeviceSetup";
import VerifySubtenant from "./VerifySubtenant";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "onboarding",
  computed: {
    ...mapGetters("onboarding", ["currentLevel"]),
  },
  components: {
    [DeviceSetup.name]: DeviceSetup,
    [VerifySubtenant.name]: VerifySubtenant,
  },
  methods: {
    ...mapActions("onboarding", ["resetLevel", "resetData"]),
    backToMainPage() {
      this.resetData();
    },
    isStage() {
      return process.env.VUE_APP_SLOT == "Stage";
    },
  },
  mounted() {
    this.resetLevel();
    this.resetData();
  },
};
</script>

<style>
.v-stepper {
  -webkit-box-shadow: null;
  box-shadow: null;
}
</style>
